import { observer } from "mobx-react";
import _ from "lodash";
import { IModal } from "../../stores";
import { Modal, ModalHeader, ModalBody } from "react-bootstrap";

interface IPreviewVoucherEmail extends IModal {
  emailBody: string;
}

const PreviewVoucherEmail = observer(
  ({ show, setShowModal, emailBody }: IPreviewVoucherEmail) => {
    return (
      <Modal
        show={show}
        onHide={() => setShowModal(false)}
        className="modal-lg"
      >
        <ModalHeader closeButton>
          <Modal.Title>
            <h5>Voucher Email Preview</h5>
          </Modal.Title>
        </ModalHeader>
        <ModalBody>
          <iframe
            srcDoc={emailBody}
            style={{ width: "100%", height: 500, border: "1px solid #ddd" }}
            sandbox="allow-same-origin"
          ></iframe>
        </ModalBody>
      </Modal>
    );
  }
);

export default PreviewVoucherEmail;
